import ToolBar from "../../Components/ToolBar/ToolBar";
import { toast } from "react-toastify";
import { useContext, useState, useRef, useEffect } from "react";
import AppContext from "../../Context/AppContext";
import {
  RestSkuBatchInventoryListRequest,
  SKUBatchInventorySearchCriteria,
  PageListBean,
  BatchInventorySummaryDataPrintRequest,
  SKUBatchInventoryTrackSearchCriteria,
  RestSKUBatchInventoryTrackListRequest,
  CriticalPathManagementInquiryCriteria,
  RestCpmReportDetailsListRequest,
} from "../../Ds/ds";
import { RestReportBean } from "../../Ds/client_ds";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
  toCommaSeperatedAmount,
  ColumnDefinition,
} from "../../Utils/util";
import PageBar from "../../Components/ToolBar/PageBar";
import Loader from "../../Components/Loder";
import InputTextBox from "../../Components/Base/InputTextBox";
import CustomButton from "../../Components/Base/CustomButton";
import service from "../../Services/Service";
import {
  TOAST_ERROR,
  TOAST_SUCESS,
  TOAST_THEME_COLOR,
  TOAST_WARN,
} from "../../Utils/appConstants";
import InValidAccess from "../../Components/InValidAccess";
import { SecurityAccessManager } from "../../Security/SecurityAccessManager";
import NoData from "../../Components/NoData";
import CustomTable from "../../Components/Base/CustomTable";
import ViewToggle from "../../Components/ViewToggle";
import { MINUSICON, PLUSICON } from "../../Utils/icons";
import { MdFullscreen, MdFullscreenExit } from "react-icons/md";
export default function CPMReportInquiry() {
  const title = "CPM Report";
  const { token, setisSessionExpeired, session } = useContext(AppContext);
  const [view, setView] = useState(window.innerWidth <= 768 ? 1 : 2);
  const [code, setCode] = useState("");
  const [cpmData, setCpmData] = useState([]);
  const [pageSize, setPageSize] = useState(50);
  const [page, setPage] = useState(1);
  const [maxPage, setMaxPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isShowPdf, setIsShowPdf] = useState(false);
  const [isShowExcel, setIsShowExcel] = useState(false);
  const [disable, setDisable] = useState(false);
  const [isAccessible, setIsAccessible] = useState(false);

  const [subTable, setSubTable] = useState(false);

  const [cpmCode, setCpmCode] = useState("");
  const [isFullscreen, setFullscreen] = useState(false);
  const [criteria, setCriteria] = useState(
    new CriticalPathManagementInquiryCriteria()
  );

  const inputRef = useRef(null);
  const buttonRef = useRef(null);
  useEffect(() => {
    function handleResize() {
      setView(getDefaultView());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  function getDefaultView() {
    return window.innerWidth <= 768 ? 1 : 2;
  }
  const setFocus = () => {
    if (inputRef.current != null) inputRef.current.focus();
  };
  useEffect(() => {
    if (!isEmpty(session)) {
      const { entityCode, code } = session;
      if (!isEmptyString(entityCode)) setCode(entityCode);
    }
    setFocus();
  }, []);

  const toggleFullscreen = () => {
    setFullscreen(!isFullscreen);
    /* If entering fullscreen, add an event listener to exit fullscreen on escape key press */
    if (!isFullscreen) {
      document.addEventListener("keydown", handleEscapeKey);
    } else {
      /* If exiting fullscreen, remove the event listener */
      document.removeEventListener("keydown", handleEscapeKey);
    }
  };

  const handleEscapeKey = (event) => {
    if (event.key === "Escape") {
      setFullscreen(false);
    }
  };
  const enterKeyHandler = (e) => {
    loadFirst();
  };
  const codeOnChange = (e) => {
    setCode(e.target.value.toUpperCase());
  };
  const onChange = (e) => {
    const criteria = new CriticalPathManagementInquiryCriteria();
    criteria[e.target.name] = e.target.value.toUpperCase();
    setCriteria(criteria);
  };

  const buttonHandler = (e) => {
    loadFirst();
  };
  const listViewHandler = () => {
    setView(1);
  };
  const gridViewHandler = () => {
    setView(2);
  };
  const onClose = () => {
    setIsAccessible(false);
  };
  const notify = (type, msg, theme) => {
    if (type === 1)
      toast.info(msg, {
        theme: theme,
      });
    else if (type === 2)
      toast.error(msg, {
        theme: theme,
      });
    else if (type === 3)
      toast.success(msg, {
        theme: theme,
      });
    else if (type === 4)
      toast.warn(msg, {
        theme: theme,
      });
    else toast(msg);
  };
  const errorCallBack = (error) => {
    setIsLoading(false);
    notify(TOAST_ERROR, error.message);
  };
  const handleResponse = (response) => {
    let msg = "";
    let msg_List = new Array();
    if (!isEmpty(response.data)) {
      if (response.data.isSessionExpired) {
        setisSessionExpeired(true);
      } else if (response.data.isSuccess) {
        if (
          !isEmpty(response.data.cpmDetail) &&
          !isEmptyArray(response.data.cpmDetail.infos)
        ) {
          setCpmData(response.data.cpmDetail.infos);
          setIsShowExcel(true);
          setIsShowPdf(true);
        }
        if (
          !isEmpty(response.data.cpmDetail) &&
          isEmptyArray(response.data.cpmDetail.infos)
        ) {
          notify(TOAST_WARN, "No Data Found");
        }
        if (!isEmptyArray(response.data.infos)) {
          response.data.infos.map((info) => {
            msg_List.push(info.messageDescription);
          });
          msg = msg_List.toString();
          notify(TOAST_SUCESS, msg);
        }
      } else {
        if (!isEmptyArray(response.data.errors)) {
          response.data.errors.map((error) => {
            msg_List.push(error.messageDescription);
          });
          msg = msg_List.toString();
          notify(TOAST_ERROR, msg);
        }
      }
    }
    setIsLoading(false);
  };
  const loadPage = (id) => {
    // if (SecurityAccessManager.SkuBatchInventoryInquiry_IsAccessible()) {
    setCpmData([]);
    setIsLoading(true);
    // const criteria = new CriticalPathManagementInquiryCriteria();
    criteria.companyCode = process.env.REACT_APP_COMPANY;
    criteria.customerCode = code;

    const path = "inquireCpmDetailReport";
    service(token, path, criteria, handleResponse, errorCallBack);
    // } else {
    //   setIsAccessible(true);
    // }
  };
  const loadFirst = () => {
    loadPage(1);
  };
  const loadPrevious = () => {
    if (page > 1) {
      const pagenumber = parseInt(page) - 1;
      loadPage(pagenumber);
    }
  };
  const loadNext = () => {
    if (maxPage > page) {
      const pagenumber = parseInt(page) + 1;
      loadPage(pagenumber);
    }
  };
  const loadLast = () => {
    loadPage(maxPage);
  };
  const handleReportResponse = (response) => {
    let msg = "";
    let msg_List = new Array();
    if (response.data != null) {
      if (response.data.isSessionExpired) {
        setisSessionExpeired(true);
      } else if (response.data.isSuccess) {
        if (response.data.reportResult != null) {
          if (!isEmptyString(response.data.reportResult.reportFileID)) {
            let reportFilePath = response.data.reportResult.reportFileID;
            window.open(
              `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_REPORT_PATH}` +
                reportFilePath
            );
          }
        }
        if (!isEmptyArray(response.data.infos)) {
          response.data.infos.map((info) => {
            msg_List.push(info.messageDescription);
          });
          msg = msg_List.toString();
          notify(TOAST_SUCESS, msg);
        }
      } else {
        if (!isEmptyArray(response.data.errors)) {
          response.data.errors.map((error) => {
            msg_List.push(error.messageDescription);
          });
          msg = msg_List.toString();
          notify(TOAST_ERROR, msg);
        }
      }
    }
    setIsLoading(false);
  };
  const generateReport = (type) => {
    // const criteria = new CriticalPathManagementInquiryCriteria();
    criteria.customerCode = code;

    criteria.containerNumber = criteria.containerNumber;
    criteria.companyCode = process.env.REACT_APP_COMPANY;
    //  if (!isEmpty(session)) {
    //    const { entityCode, code } = session;
    //    if (!isEmptyString(entityCode))
    //      criteria.logisticCustomerCode = entityCode;
    //    if (!isEmptyString(code)) criteria.customerUserCode = code;
    //  }
    const reportBean = new RestReportBean();
    reportBean.reportType = type;
    const request = new RestCpmReportDetailsListRequest();
    request.searchCriteria = criteria;
    request.reportBean = reportBean;
    const path = "generateCpmReportDetailsPrintReport";
    service(token, path, request, handleReportResponse, errorCallBack);
  };
  const PDFHandler = () => {
    // if (
    //   SecurityAccessManager.SkuBatchInventoryInquiryPDFReport_IsAccessible()
    // ) {
    setIsLoading(true);
    generateReport(1);
    // } else {
    //   setIsAccessible(true);
    // }
  };
  const ExcelHandler = () => {
    // if (
    //   SecurityAccessManager.SkuBatchInventoryInquiryExcelReport_IsAccessible()
    // ) {
    setIsLoading(true);
    generateReport(2);
    // } else {
    //   setIsAccessible(true);
    // }
  };
  const ResetHandler = () => {
    setCode("");
    setCpmData([]);
    setDisable(false);
    setIsShowExcel(false);
    setIsShowPdf(false);
    setSubTable(false);
    setCpmCode(false);
    setFocus();
    setCriteria(new CriticalPathManagementInquiryCriteria());
  };
  const ExecuteHandler = () => {
    loadPage(1);
  };
  const colButtonHandler = (e, val, row) => {
    setCpmCode(val);
    cpmData.map((ln) => {
      if (ln.cpmCode == val) {
        setCpmCode(val);
        setSubTable(true);
      }
    });
    if (cpmCode == row.cpmCode) {
      if (subTable) {
        setSubTable(false);
        setCpmCode("");
      }
    }
  };
  const cpmClick = (val, e, row) => {
    // setSubInfos([row.cpmDetailInfos]);
  };
  const Columns = () => {
    const _columns = new Array();
    _columns.push(
      new ColumnDefinition()
        .setDetails("", <PLUSICON />, false)
        .setStyleDetails("center", "2", "", "wt-2", "wt-2")
        .setClickDetails(true, true, cpmClick, <PLUSICON />)
      // .setSubTableDetails(true)
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("CPM", "code", true)

        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
        .setSubTableDetails(true, "taskCode")
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("Customer", "customerCode", true)

        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
    );
    _columns.push(
      new ColumnDefinition()
        .setDetails("Name", "customerName", true)

        .setStyleDetails("left", "10", "", "wt-4", "wt-4")
    );

    _columns.push(
      new ColumnDefinition()
        .setDetails("ContainerNumber", "containerNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3")
    );

    return _columns;
  };

  return (
    <>
      {" "}
      {isLoading ? <Loader /> : null}
      <ToolBar
        title={title}
        PDFHandler={PDFHandler}
        ExcelHandler={ExcelHandler}
        ResetHandler={ResetHandler}
        ExecuteHandler={ExecuteHandler}
        isShowPdf={isShowPdf}
        isShowExcel={isShowExcel}
      />{" "}
      <div className="card-body">
        <div className="row">
          {/* <div className="form-group col-5">
            <InputTextBox
              value={code}
              required={true}
              name="code"
              placeholder={"Enter customer code"}
              label={"Customer Code"}
              enterKeyHandler={enterKeyHandler}
              onChange={codeOnChange}
              disable={disable}
              inputRef={inputRef}
              readOnly={true}
            />
          </div> */}
          <div className="form-group col-5">
            <InputTextBox
              value={criteria.containerNumber}
              required={true}
              name="containerNumber"
              placeholder={"Enter ContainerNumber"}
              label={"Container Number"}
              enterKeyHandler={enterKeyHandler}
              onChange={onChange}
              disable={disable}
              inputRef={inputRef}
            />
          </div>
          <div className="form-group col-fit">
            <CustomButton
              buttonHandler={buttonHandler}
              disable={disable}
              buttonRef={buttonRef}
              label={"Fetch"}
            />
          </div>
        </div>
      </div>
      {/* {!isEmptyArray(cpmData) ? (
        <PageBar
          loadFirst={loadFirst}
          loadNext={loadNext}
          loadPrevious={loadPrevious}
          loadLast={loadLast}
          page={page}
        />
      ) : null} */}
      {!isEmptyArray(cpmData) ? (
        <ViewToggle
          listViewHandler={listViewHandler}
          gridViewHandler={gridViewHandler}
        />
      ) : null}
      {!isEmptyArray(cpmData) ? (
        <div className="card-body">
          <div
            className={`header_div table-wrap  ${
              isFullscreen ? " full-screen" : ""
            }`}
          >
            <div className="card-title">
              <h1>CPM Report Details</h1>
            </div>
            <div className="fullScreen-toggle">
              {" "}
              {isFullscreen ? (
                <MdFullscreenExit
                  onClick={toggleFullscreen}
                  className="full-screen-toggle"
                />
              ) : (
                <MdFullscreen
                  onClick={toggleFullscreen}
                  className="full-screen-toggle"
                />
              )}
            </div>
            <div className="list-wrap">
              {view === 2 ? (
                <>
                  {" "}
                  <table className="table">
                    <thead>
                      <tr>
                        <th></th>
                        <th>Cpm</th>
                        <th>CustomerCode</th>
                        <th>CustomerName</th>
                        <th>ContainerNumber</th>
                      </tr>
                    </thead>

                    {cpmData.map((cpm, index) => (
                      <>
                        <tbody>
                          <tr key={index}>
                            <td className="list-icon-wrap">
                              {cpm.cpmCode == cpmCode ? (
                                <CustomButton
                                  cstmClass="icon-wrap"
                                  buttonHandler={(e) =>
                                    colButtonHandler(e, cpm.cpmCode, cpm)
                                  }
                                  buttonRef={buttonRef}
                                  label={<MINUSICON />}
                                />
                              ) : (
                                <CustomButton
                                  cstmClass="icon-wrap"
                                  buttonHandler={(e) =>
                                    colButtonHandler(e, cpm.cpmCode, cpm)
                                  }
                                  buttonRef={buttonRef}
                                  label={<PLUSICON />}
                                />
                              )}
                            </td>
                            <td>{cpm.cpmCode}</td>
                            <td>{cpm.customerCode}</td>
                            <td>{cpm.customerName}</td>
                            <td>{cpm.containerNumber}</td>
                          </tr>

                          {cpm.cpmCode == cpmCode ? (
                            subTable ? (
                              <tr>
                                <td colSpan={6}>
                                  <table className="table">
                                    <thead>
                                      <tr>
                                        <th>Task</th>
                                        <th>Sched_Date</th>
                                        <th>Sched_Time</th>
                                        <th>StartDate</th>
                                        <th>StartTime</th>
                                        <th>EndDate</th>
                                        <th>EndTime</th>
                                        <th>Duration(hrs)</th>
                                        <th>Comments</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {cpm.cpmDetailInfos.map((web, i) =>
                                        cpm.cpmCode === web.cpmCode ? (
                                          <tr key={i}>
                                            <td>{web.taskCode}</td>
                                            <td>{web.scheduledDate}</td>
                                            <td>{web.scheduledTime}</td>
                                            <td>{web.startDate}</td>
                                            <td>{web.startTime}</td>
                                            <td>{web.endDate}</td>
                                            <td>{web.endTime}</td>
                                            <td>{web.duration}</td>
                                            <td>{web.comments}</td>
                                          </tr>
                                        ) : null
                                      )}
                                    </tbody>
                                  </table>
                                </td>
                              </tr>
                            ) : null
                          ) : null}

                          <tr></tr>
                        </tbody>
                      </>
                    ))}
                  </table>
                </>
              ) : (
                <>
                  {cpmData.map((cpm, idx) => {
                    return (
                      <div className="list-itm" key={idx}>
                        <div className="">
                          <span className="_imp">{cpm.customerCode}</span>-{" "}
                          {cpm.customerName}
                        </div>

                        <div className="tb-flex">
                          <div>ContainerNumber</div>
                          <div>
                            ({" "}
                            <span className="_imp">{cpm.containerNumber}</span>{" "}
                            )
                          </div>
                        </div>

                        <div className="tb-flex">
                          <table className="table">
                            <thead>
                              <tr>
                                <th className="text-left">Task</th>
                                <th className="text-left">Sched.Date</th>
                              </tr>
                            </thead>
                            <tbody>
                              {cpm.cpmDetailInfos.map((ln) => (
                                <tr>
                                  <td className="text-left">{ln.taskCode}</td>
                                  <td className="text-left">
                                    {ln.scheduledDate}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>

                        <hr />
                      </div>
                    );
                  })}
                </>
              )}
            </div>
          </div>
        </div>
      ) : null}
      <InValidAccess isShow={isAccessible} clickHandler={onClose} />
    </>
  );
}
